import React from "react";
import styled from "styled-components";
import TextShift from "../../utils/TextShift";
import WorkButtons from "./WorkButtons";
import RevealOnScroll from "../../utils/RevealOnScroll";

const StyledHeader = styled.header`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 4;
  width: 100%;
  max-width: 1200px;
  height: 100%;

  @media (max-width: 768px) {
    padding-top: 1rem;
  }
`;

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h1`
  font-weight: 300;
  color: white;
  margin-bottom: -4rem;

  @media (max-width: 768px) {
    font-size: 3rem;
    margin-bottom: -1rem;
  }
`;

const Subtitle = styled.h2`
  font-size: 3rem;
  font-weight: 200;
  color: #606060;
  opacity: 0.8;
  font-family: "Maitree";
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    color: #cccccc;
  }
`;

const RevealWrapper = styled.div`
  width: 100%;
  margin-top: 2rem;
  display: flex;
  justify-content: center;
`;

function Header() {
  return (
    <HeaderContainer>
      <StyledHeader>
        <RevealOnScroll>
          <Title>
            <TextShift
              text="NOAH KORNBERG"
              maxWeight={800}
              minWeight={300}
              fontSize="9rem"
              mobileFontSize="3.5rem"
              adjacentWeightChange={100}
              fontFamily="moret-variable"
            />
          </Title>
        </RevealOnScroll>
 
        <RevealWrapper>
          <RevealOnScroll threshold={[0.1]} delay={100}>
            <WorkButtons />
          </RevealOnScroll>
        </RevealWrapper>
      </StyledHeader>
    </HeaderContainer>
  );
}

export default Header;
